import { applicationsData } from "./applications.data";

import bluePlus from "./bluePlus.svg";
import editIcon from "./Vector-1.png";

import deleteIcon from "../../../../../assets/icons/delete_plus.svg";


import Footer from "../../../../layout/Footer/Footer";
import ReplacementModal from "../../../../common/Modal/Replacement/ReplacementModal/ReplacementModal";
import ModalBanOverlay from "../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import ErrorModal from "../../../../common/Modal/ModalConditions/Profile/ErrorModal/ErrorModal";
import Breadcrumbs from "../../../../common/Breadcrumbs/Breadcrumbs";


import Header from "../../../../layout/Header/Header";


import {
    getActiveRequestDelegations,
} from "../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/getActiveDelegations.thunk.action";
import {
    clearActiveDelegations,
} from "../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/clearActiveRequestsDelegations.action";
import {
    deleteRequestDelegationThunkAction,
} from "../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/deleteDelegation.thunk.action";

import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";

import "./RequestDelegation.scss";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";


const AddDelegation = (
    {
        parentStyle,
        // setState,
    },
) => {
    const navigate = useNavigate();



    return (
        <div className={"request-delegations__add__button"}>
            <span>Добавить делегирование</span>
            <img
                onClick={()=>navigate("/divisions/structure/request-delegation/transfer")}
                className={"request-delegations__add__button__blue-plus"}
                src={bluePlus}
                alt="bluePlus"
            />
        </div>
    );
};

const RequestDelegation = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const requestsDelegations = useSelector(state => state.myDivision.requestsDelegations);

    const [statusModal, setStatusModal] = React.useState({ status: false, loading: false,  message: "", delete: false });

    function closeModal() {
        setStatusModal({ status: false, message: "", loading: false, delete: false });
    }
    function deleteSubstitutionStatus(element) {
        if (!statusModal.loading ) {
            console.log(statusModal.loading);
            setStatusModal({...statusModal,
                delete: true,
                loading: false,
                employee: element,
            });
        }
    }
    function deleteSubstitution() {
        setStatusModal({
            ...statusModal,
            loading: true,
            id: statusModal.employee.id,
            delete: false,
        });

        dispatch(deleteRequestDelegationThunkAction({id: statusModal.employee.id, statusModal, setStatusModal }));
    }
    function isDateInRange(date, startDate, endDate) {
        const startOfStartDate = new Date(startDate);
        startOfStartDate.setHours(0, 0, 0, 0);

        date.setHours(0, 0, 0, 0);

        const endOfEndDate = new Date(endDate);
        endOfEndDate.setHours(0, 0, 0, 0);

        return date >= startOfStartDate && date <= endOfEndDate;
    }

    useEffect(() => {
        dispatch(getActiveRequestDelegations({option: "initiator"}));
        return()=>{
            dispatch(clearActiveDelegations());
        };
    }, []);

    console.log(requestsDelegations);
    return (
        <>
            <Header />
            <Breadcrumbs />
            <div className={"delegation-of-responsibilities"}>

                <h3 className="sub-header">делегирование полномочий</h3>
                <AddDelegation/>
                {/*<MultiRoute*/}
                {/*    styleParent={"divisions"}*/}
                {/*    subHeader={"Замещение"}*/}
                {/*    breadCrumbs={true}*/}
                {/*    data={data} />*/}
                {/*TODO REFACTOR MULTI-ROUTE! MAX MIN HEIGHT! */}
                <table className="table">
                    <thead>
                        <tr className="table__row">
                            {applicationsData && applicationsData.map((el) => {
                                return (
                                    <th
                                        key={el.id}
                                        style={{ width: `${el.width}`, textAlign: "center" }}
                                        className="delegation-of-responsibilities__rows__item"
                                    >
                                        {el.title}
                                        {
                                            el.icon
                                                ? <img
                                                    src={el.icon}
                                                    alt="triangle"
                                                    className="header-triangle" />
                                                : null
                                        }
                                    </th>
                                );
                            })
                            }
                        </tr>
                    </thead>
                    {
                        requestsDelegations ?
                            ( requestsDelegations.length > 0  ?
                                <tbody>
                                    {requestsDelegations && requestsDelegations.map((el, i) => (
                                        <tr
                                            key={el.id}
                                            className={
                                                isDateInRange(new Date(), el.from, el.to) ?
                                                    "delegation-of-responsibilities__rows-active" :
                                                    "delegation-of-responsibilities__rows"
                                            }
                                        >
                                            <td style={{ width:  "150px" }}>{el.initiator.fullName}</td>
                                            <td style={{ width:  "150px", textAlign: "center" }}>{el.initiator.jobTitle}</td>
                                            <td style={{ width:  "150px" }}>{el.delegate.fullName}</td>
                                            <td style={{ width:  "150px", textAlign: "center" }}>{el.delegate.jobTitle}</td>
                                            <td style={{ width:  "170px" }}>
                                                {el.applicationTypes && el.applicationTypes.length && el.applicationTypes.map((e, index) => {
                                                    console.log(e);
                                                    return (
                                                        <span key={uuidv4()}>
                                                            { index !== (el.applicationTypes.length - 1) ? `${ e.name ? e.name : "" }, ` : `${ e.name ? e.name : "" }` }
                                                        </span>
                                                    );
                                                })}
                                            </td>

                                            <td style={{ width:  "108px", textAlign: "center"  }}>{moment(el.from).format("DD.MM.YYYY")}</td>
                                            <td  style={{ width:  "108px", textAlign: "center"}}>
                                                {el.to ?  moment(el.to).format("DD.MM.YYYY") : <div style={{fontSize: "26px", fontWeight: "lighter"}}>{"\u221E"}</div>  }
                                            </td>
                                            <td
                                            // onClick={(e) => e.stopPropagation()}
                                                style={{ width:  "60px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center"  }}>
                                                    <div>
                                                        <img className={"table-img"}
                                                            onClick={ ()=>navigate(`revoke/${el.id}`)}
                                                            src={editIcon} alt="" />
                                                    </div>

                                                    {
                                                    //  new Date(el.from).getTime() > new Date().getTime()
                                                        ! isDateInRange(new Date(), el.from, el.to)
                                                            ?  (
                                                                <div  id = {el.id}>
                                                                    {
                                                                        ( statusModal.loading && statusModal.id === el.id) ?
                                                                            <ClipLoader color={"#6DCDF6"}/> :
                                                                            <img className={"table-img"}
                                                                                onClick={ ()=>deleteSubstitutionStatus(el)}
                                                                                src={deleteIcon} alt="" />
                                                                    }

                                                                </div>
                                                            )
                                                            :
                                                            <span className={"popup-notification"}>

                                                                <img style={{opacity: "30%", filter: "grayscale(100%)"}} className={"table-img"}
                                                                // onClick={ ()=>deleteSubstitutionStatus(el)}
                                                                    src={deleteIcon} alt="" />
                                                                {/*<img style={{marginLeft: "0px",width: "26px" }} className={"table-img"} src={info} alt="#" />*/}
                                                                <div className="custom-uploader__item__name__label">
                                                                           Данное делегирование является действующим и не может быть удалено.
                                                                             При необходимости прекращения делегирования скорректируйте его конечную дату.
                                                                </div>
                                                            </span>


                                                    }
                                                </div>


                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                :
                                <div className={"replacement-modal__body"}>
                                    <span style={{opacity:"70%"}}  className={"table__row__item"}>
                                    Делегирования отсутствуют
                                    </span>
                                </div>) :
                            <div style={{margin: " 100px auto" , height: "200px", width: "200px"}}>
                                <ClipLoader color={"#6DCDF6"}/>
                            </div>
                    }

                </table>
                <div style={{height: "10vh"}}></div>
            </div>
            <ModalBanOverlay shown={statusModal.status} close={closeModal}>
                <ErrorModal
                    description={statusModal.message}
                    setError={setStatusModal}
                    funk = {deleteSubstitution}
                    route={"/divisions/structure/request-delegation"}
                    okButton={"удалить"}
                />
            </ModalBanOverlay>
            <ModalBanOverlay shown={statusModal.delete} close={closeModal}>
                <ReplacementModal
                    delegation = {"делегирование"}
                    close={closeModal}
                    proceed={deleteSubstitution}
                    modalData={statusModal.employee}
                />
            </ModalBanOverlay>

            <Footer />
        </>
    );
};
export default RequestDelegation;
